import { render, staticRenderFns } from "./chronicleRecent.vue?vue&type=template&id=0ec078e4&scoped=true"
import script from "./chronicleRecent.vue?vue&type=script&lang=js"
export * from "./chronicleRecent.vue?vue&type=script&lang=js"
import style0 from "./chronicleRecent.vue?vue&type=style&index=0&id=0ec078e4&prod&scoped=true&lang=css"
import style1 from "./chronicleRecent.vue?vue&type=style&index=1&id=0ec078e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec078e4",
  null
  
)

export default component.exports